import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { Separator } from "@/components/ui/separator";

const footerCollections = [
{ name: "Bijoux souvenir avec poils", href: "/bijoux/bijoux-souvenir-avec-poils" },
{ name: "Boucles d'oreilles", href: "/bijoux/boucles-d-oreilles" },
{ name: "Breloques", href: "/bijoux/breloques" },
{ name: "Colliers", href: "/bijoux/colliers" },
{ name: "Médailles", href: "/bijoux/medailles" },
{ name: "Noël", href: "/bijoux/noel" },
{ name: "Porte-clés", href: "/bijoux/porte-cles" }];


const footerNav = [
{ name: "Accueil", href: "/" },
{ name: "Tous les bijoux", href: "/bijoux" },
{ name: "Comment ça marche", href: "/comment-ca-marche" },
{ name: "À propos", href: "/a-propos" },
{ name: "Commander", href: "/commander" }];


const footerLegal = [
{ name: "Politique de confidentialité", href: "/politique-confidentialite" },
{ name: "Conditions générales", href: "/conditions-generales" },
{ name: "Mentions légales", href: "/mentions-legales" }];


export default function Footer() {
  return (
    <footer
      data-testid="main-footer"
      className="bg-white/40"
      style={{ borderTop: "1px solid rgba(122,63,145,0.10)" }}>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-flex items-center gap-3 group" data-testid="footer-logo">
              <img
                src="/images/logo.webp"
                alt="Sublime Résine"
                className="h-12 w-12 object-contain shrink-0"
              />
              <span className="font-script text-3xl text-brand-title leading-none transition-colors group-hover:text-brand-primary">
                Sublime Résine
              </span>
            </Link>
            <p className="mt-4 text-sm font-body text-brand-body/70 leading-relaxed max-w-xs">
              Créations artisanales en résine personnalisées pour immortaliser vos compagnons à quatre pattes.
            </p>
            <p className="mt-4 text-xs font-body text-brand-secondary italic">
              Toutes les créations sont personnalisables selon vos envies.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-xs font-body font-semibold uppercase tracking-widest text-brand-secondary mb-4">
              Navigation
            </h3>
            <ul className="space-y-2.5">
              {footerNav.map((item) =>
              <li key={item.href}>
                  <Link
                  to={item.href}
                  data-testid={`footer-nav-${item.href.slice(1) || "accueil"}`}
                  className="text-sm font-body text-brand-body/80 hover:text-brand-primary transition-colors">

                    {item.name}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Collections */}
          <div>
            <h3 className="text-xs font-body font-semibold uppercase tracking-widest text-brand-secondary mb-4">
              Collections
            </h3>
            <ul className="space-y-2.5">
              {footerCollections.map((item) =>
              <li key={item.href}>
                  <Link
                  to={item.href}
                  data-testid={`footer-col-${item.href.split("/").pop()}`}
                  className="text-sm font-body text-brand-body/80 hover:text-brand-primary transition-colors">

                    {item.name}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Legal + Supplements */}
          <div>
            <h3 className="text-xs font-body font-semibold uppercase tracking-widest text-brand-secondary mb-4">
              Informations
            </h3>
            <ul className="space-y-2.5">
              {footerLegal.map((item) =>
              <li key={item.href}>
                  <Link
                  to={item.href}
                  data-testid={`footer-legal-${item.href.slice(1)}`}
                  className="text-sm font-body text-brand-body/80 hover:text-brand-primary transition-colors">

                    {item.name}
                  </Link>
                </li>
              )}
            </ul>
            <div
              className="mt-6 p-4 rounded-2xl"
              style={{
                background: "rgba(255,255,255,0.50)",
                border: "1px solid rgba(122,63,145,0.10)",
              }}
            >
              <p className="text-xs font-body font-semibold text-brand-title mb-2">Suppléments</p>
              <ul className="space-y-1 text-xs font-body text-brand-body/80">
                <li>Photo : +5 $</li>
                <li>Poils : +10 $</li>
                <li>Livraison Poste Canada : +5 $</li>
              </ul>
            </div>
          </div>
        </div>

        <Separator className="my-12 bg-[rgba(197,157,217,0.2)]" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs font-body text-brand-body/60">
            &copy; {new Date().getFullYear()} Sublime Résine. Tous droits réservés.
          </p>
          <p className="flex items-center gap-1.5 text-xs font-body text-brand-body/60">
            Fait avec <Heart className="w-3 h-3 text-brand-secondary fill-brand-secondary" /> au Québec par Création Synergie
          </p>
        </div>
      </div>
    </footer>);

}